import { Color, DoubleSide, Mesh, MeshBasicMaterial, Object3D, PlaneBufferGeometry } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Global } from '../../global.model';
import { Simulation } from '../../simulation.model';
import ObjectBuilder from './object-builder.model';

export class GlobalBuilder extends ObjectBuilder {
  public static readonly DEFAULT_OPACITY = 0.4;

  public static readonly MIN_WORLD_SIZE = 2000;
  public static readonly LINEAR_LIMIT = 3600;
  public static readonly LINEAR_GROW = 1.4;
  public static readonly ARCTAN_COEFF = 1300;

  public static getPlaneSize(depth: number): number {
    if (depth <= this.MIN_WORLD_SIZE / this.LINEAR_GROW) {
      return this.MIN_WORLD_SIZE;
    }

    if (depth <= this.LINEAR_LIMIT) {
      return depth * this.LINEAR_GROW;
    }

    return (
      this.ARCTAN_COEFF * Math.atan((depth - this.LINEAR_LIMIT) / this.ARCTAN_COEFF) +
      this.LINEAR_LIMIT * this.LINEAR_GROW
    );
  }

  constructor() {
    super();
  }

  async build(riser: Catenary3D, simulation: Simulation, global: Global): Promise<Object3D> {
    const size = GlobalBuilder.getPlaneSize(global.seabedDepth);
    const sea = this.drawSurface(global, size);
    const soil = this.drawSoil(global, size);

    const globalObj = new Object3D().add(sea).add(soil);
    globalObj.name = 'global-planes';
    return globalObj;
  }

  createGeometry(_: Catenary3D, size: number): PlaneBufferGeometry {
    return new PlaneBufferGeometry(size, size);
  }

  createMaterial(_: Catenary3D, color: Color): MeshBasicMaterial {
    return new MeshBasicMaterial({ color, side: DoubleSide });
  }

  drawSurface(global: Global, size: number): Mesh {
    const geometry = this.createGeometry(null, size);
    const material = this.createMaterial(null, new Color('#72bcb4'));
    const surface = new Mesh(geometry, material);

    surface.position.z = global.seabedDepth;
    surface.material.opacity = GlobalBuilder.DEFAULT_OPACITY;
    surface.material.transparent = true;

    return surface;
  }

  drawSoil(global: Global, size: number): Mesh {
    const geometry = this.createGeometry(null, size);
    const material = this.createMaterial(null, new Color('#b4af6d'));
    const soil = new Mesh(geometry, material);

    soil.material.opacity = GlobalBuilder.DEFAULT_OPACITY;
    soil.material.transparent = true;

    return soil;
  }

  transform(global: Global): void {}
}
